<script lang="ts">
	import { page } from '$app/state';
	import TabbedAccordion from '$lib/accordion/tabbedAccordion.svelte';

	let { data } = $props();
</script>

<TabbedAccordion
	categories={data.content.faqCategories}
	selectedTab={page.params.slug}
	items={data.content.faqItems}
	theme="brown"
	supportLink={{ title: data.content.supportHeadline, link: data.content.supportLink }}
/>
